import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ReactComponent as DownArrowIcon } from '@src/assets/escher/icons/arrow-drop-down.svg';

import ErrorMessage from '../Input/ErrorMessage';

export default function Select({
  error,
  onChange,
  optional,
  options,
  placeholder,
  type,
  value,
  ...rest
}) {
  return (
    <>
      <StyledInputContainer error={error}>
        <StyledSelect
          {...rest}
          id={placeholder}
          onChange={onChange}
          placeholder={placeholder}
          required={!optional}
          type={type}
          value={value}
        >
          <option disabled value=''>
            {placeholder}
          </option>
          {options.map(([optionKey, optionValue]) => (
            <option value={optionKey} key={optionKey}>
              {optionValue}
            </option>
          ))}
        </StyledSelect>
        <StyledArrowIcon />
      </StyledInputContainer>
      {error && <ErrorMessage error={error} />}
    </>
  );
}

Select.propTypes = {
  error: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  optional: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

Select.defaultProps = {
  onChange: () => {},
  type: 'text',
};

const StyledSelect = styled.select`
  transition: 0.25s border-color ease;
  appearance: none;
  background: none;
  border-radius: ${props => props.theme.inputBorderRadius};
  border: ${props => props.theme.borderMd};
  box-shadow: none;
  color: ${props => (props.value ? props.theme.primary : '#747474')};
  font-size: ${props => props.theme.font.fontLg};
  height: ${props =>
    props.style && props.style.height ? props.style.height : '56px'};
  outline: none !important;
  padding: 0 16px;
  width: ${props =>
    props.style && props.style.width ? props.style.width : '100%'};

  &:disabled {
    background-color: #f8f8f8;
  }

  &:focus {
    border-color: ${props => props.theme.enigmaBlue};
    + label {
      color: ${props => props.theme.enigmaBlue};
    }
  }
`;

const StyledInputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledArrowIcon = styled(DownArrowIcon)`
  position: absolute;
  right: 10px;
  top: 16px;

  path {
    fill: #767676;
  }
`;
